import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { contactsApi } from '../../api';

interface BookStatusGuardProps {
  children: React.ReactNode;
}

export const BookStatusGuard: React.FC<BookStatusGuardProps> = ({ children }) => {
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkStatus = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const { data } = await contactsApi.getMy();
        setStatus(data.status || null);
      } catch {
        // No contact data yet — not done
      } finally {
        setLoading(false);
      }
    };

    checkStatus();
  }, [location.pathname]);

  if (loading) return null;

  if (status === 'done') {
    return <Navigate to="/forms" replace />;
  }

  return <>{children}</>;
};
